import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" style={{
  isolation: "isolate"
}} viewBox="0 0 20 20" width="20" height="20" {...props}><defs><clipPath id="_clipPath_NnXEtQGf71iUTzD6gGihmU6QuVZkOgKH"><path d="M0 0h20v20H0z" /></clipPath></defs><g clipPath="url(#_clipPath_NnXEtQGf71iUTzD6gGihmU6QuVZkOgKH)"><path id="$" d="M2 18h6l2 2H0V10l2 2v6zM18 2h-6l-2-2h10v10l-2-2V2z" fill="#000" /></g></svg>);